import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { openDropdownMenu, closeDropdownMenu, toggleDropdownMenu, activeItem } from './actions'

function mapStateToProps(state, hocProps) {
    return {
        activeName: state.getIn(['ui', 'modules', hocProps.moduleName, 'ribbon', hocProps.name, 'active'], null),
        open: state.getIn(['ui', 'modules', hocProps.moduleName, 'ribbon', hocProps.name, 'open'], false),
        activeBlocks: state.getIn(['ui', 'modules', hocProps.moduleName, 'ribbon', 'reportBlocks', 'data']),
        blocks: state.getIn(['authorization', 'accessRights', hocProps.moduleName, 'custom', 'reports']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ openDropdownMenu, closeDropdownMenu, toggleDropdownMenu, activeItem }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            activeBlocks: IPropTypes.map,
            activeName: PropTypes.string,
            blocks: IPropTypes.map,
            configuration: IPropTypes.list.isRequired,
            open: PropTypes.bool.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            if (this.props.open !== nextProps.open) return true
            if (this.props.activeName !== nextProps.activeName) return true
            if (!this.props.configuration.equals(nextProps.configuration)) return true
            if (!this.props.activeBlocks.equals(nextProps.activeBlocks)) return true
            if (!this.props.blocks.equals(nextProps.blocks)) return true

            return false
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
